<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Carton Amendment</h3>

            <iframe :src="pdf_to_print" id="myFrame-carton" frameborder="0" style="display: none" width="300"
                height="300"></iframe>

            <div class="row">
                <div class="col-3">
                    <b-form-input size="md" type="text" v-model="carton_obj.ctns"
                        placeholder="Actual Total Cartons 實際箱數" />
                </div>

                <div class="col-3">
                    <b-form-input ref="txt_tracking_number" size="md" type="text" v-model="carton_obj.tracking_number"
                        placeholder="Tracking #" @keydown="onTrackingKeyDown($event)" @keyup.enter="submitTracking()" />
                </div>

                <div class="col-3">
                    <b-button class="btn-action" size="md" variant="info" @click="submitTracking()" v-if="
                        checkPermission(
                            $store.state.user_obj,
                            'Warehouse Management',
                            'Carton Amendment',
                            'Amend Carton',
                            true
                        )
                    ">
                        Submit
                    </b-button>

                    <b-button v-if="
                        checkPermission(
                            $store.state.user_obj,
                            'Warehouse Management',
                            'Carton Amendment',
                            'Amend Carton',
                            true
                        )
                    " class="btn-action ml-2" size="md" variant="info" @click="openScanner">
                        Scan
                    </b-button>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col">
                    <b-alert :show="alert_config.show" :variant="alert_config.variant"
                        @dismissed="alert_config.show = false" dismissible>
                        {{ alert_config.message }}
                    </b-alert>
                </div>
            </div>

            <div class="row m-1" v-if="scannerOn">
                <b-button block class="btn-action mb-1" size="md" variant="danger" @click="closeScanner()"
                    v-if="scannerOn">
                    Close
                </b-button>

                <StreamBarcodeReader style="width: 100%;" @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
            </div>

            <h4>Scan History</h4>
            <b-table responsive small outlined striped hover sticky-header="500px" :items="scan_history"
                :fields="fields">
            </b-table>
        </b-container>
    </div>
</template>

<script>
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
    name: "OrderMaster",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService, global_function],
    components: {
        StreamBarcodeReader
    },
    data() {
        return {
            result: null,

            carton_obj: {
                ctns: null,
                tracking_number: null
            },

            tracking_input_meta: {
                timeout: null,
                prev_value: "",
                input_type: null // Barcode / Keyboard / CameraBarcode
            },

            scan_history: [],
            scannerOn: false,

            alert_config: {
                show: false,
                variant: "danger",
                message: ""
            },

            fields: [
                {
                    key: "date",
                    label: "Date"
                },
                {
                    key: "time",
                    label: "Time"
                },
                {
                    key: "tracking_number",
                    label: "Tracking #"
                },
                {
                    key: "order_number",
                    label: "Order #"
                },
                {
                    key: "no_of_ctns",
                    label: "Cartons"
                }
            ],

            camera_cooldown: false,
            pdf_to_print: false,
            printing: false
        };
    },
    async created() {
        this.initialized = true;
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.txt_tracking_number) {
                this.$refs.txt_tracking_number.focus();
            }
        });
    },
    methods: {
        resetAlert() {
            this.alert_config = {
                show: false,
                variant: "danger",
                message: ""
            };
        },

        showAlert(message, variant = "danger") {
            this.alert_config = {
                show: true,
                variant,
                message
            };
        },

        focusTrackingInput() {
            this.$nextTick(() => {
                if (this.$refs.txt_tracking_number) {
                    this.$refs.txt_tracking_number.focus();
                }
            });
        },

        clearTrackingInput() {
            this.carton_obj.ctns = null;
            this.carton_obj.tracking_number = null;
            this.tracking_input_meta.input_type = null;
            this.tracking_input_meta.prev_value = "";
            if (this.tracking_input_meta.timeout) {
                clearTimeout(this.tracking_input_meta.timeout);
                this.tracking_input_meta.timeout = null;
            }
        },

        onTrackingKeyDown(event) {
            if (event.key === "Enter") return;
            if (event.ctrlKey || event.metaKey || event.altKey) return;

            let value = this.carton_obj.tracking_number || "";
            let meta = this.tracking_input_meta;

            if (!meta.timeout) {
                meta.prev_value = value;
                let self = this;
                meta.timeout = setTimeout(() => {
                    let currentValue = this.carton_obj.tracking_number || "";
                    let diff = currentValue.length - (meta.prev_value || "").length;

                    // Similar idea as fulfilment page:
                    // many characters in a very short time => barcode
                    if (diff >= 2) {
                        meta.input_type = "Barcode";
                    } else {
                        meta.input_type = "Keyboard";
                    }

                    clearTimeout(meta.timeout);
                    meta.timeout = null;
                }, 100);
            }
        },

        submitTracking() {
            if (!this.carton_obj.tracking_number) return;
            if (this.printing) return;

            const isAllowedKeyboardInput = ["client_admin", "admin"].includes(this.$store.state.user_obj.account_type);

            if (
                !isAllowedKeyboardInput &&
                this.tracking_input_meta.input_type !== "Barcode" &&
                this.tracking_input_meta.input_type !== "CameraBarcode"
            ) {
                this.showAlert(
                    "Keyboard input is not allowed. Please scan barcode only.",
                    "danger"
                );
                this.clearTrackingInput();
                this.focusTrackingInput();
                return;
            }

            this.onSubmit(this.carton_obj.tracking_number);
        },

        async onDecode(content) {
            if (this.scannerOn && !this.camera_cooldown && !this.printing) {
                this.result = content;
                this.tracking_input_meta.input_type = "CameraBarcode";
                this.carton_obj.tracking_number = content;
                await this.onSubmit(content);
            }
        },

        onLoaded() {
            console.log("loaded barcode reader");
        },

        openScanner() {
            this.scannerOn = true;
        },

        closeScanner() {
            this.scannerOn = false;
        },

        isValidCartons() {
            let ctns = parseInt(this.carton_obj.ctns, 10);
            return Number.isInteger(ctns) && ctns > 0 && ctns <= 999;
        },

        async getTrackingInfo(tracking_number) {
            try {
                let response = await this.$http({
                    method: "POST",
                    baseURL: `${this.API_HOST}`,
                    url: "fulfilment_process_info_get.php",
                    data: {
                        tracking_number: tracking_number,
                        account_type: this.$store.state.user_obj.account_type,
                        client_id: this.$store.state.user_obj.client_id
                    }
                });

                if (
                    response.data &&
                    response.data.tracking &&
                    response.data.tracking.tracking_number
                ) {
                    return response.data.tracking;
                }
            } catch (err) {
                console.log("getTrackingInfo error", err);
            }

            return null;
        },

        printPdfFromIframe() {
            this.loader.hide();
            let objFra = document.getElementById("myFrame-carton");
            if (objFra && objFra.contentWindow) {
                objFra.contentWindow.focus();
                objFra.contentWindow.print();
            }
        },

        async autoPrintWaybill(tracking_number, no_of_ctns) {
            let tracking_obj = await this.getTrackingInfo(tracking_number);

            if (!tracking_obj || !tracking_obj.courier_short_name) {
                this.showAlert(
                    `Cartons updated, but unable to load waybill info for [${tracking_number}]`,
                    "warning"
                );
                return;
            }

            // keep print log
            await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "print_waybill_log.php",
                data: {
                    tracking_number: tracking_obj.tracking_number,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            let courier = (tracking_obj.courier_short_name || "").toLowerCase();
            let total_ctns = parseInt(no_of_ctns, 10) || 1;

            // GOLS / WHOLE: generate PDF first
            if (courier === "gols" || courier === "whole") {
                await this.$http({
                    url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
                    method: "POST",
                    data: {
                        ids: [tracking_number],
                        print_packing: false,
                        print_waybill: true,
                        no_of_waybill: total_ctns,
                        print_as_file: 1,
                        user_id: this.$store.state.user_obj.user_id
                    }
                });

                setTimeout(() => {
                    this.pdf_to_print =
                        process.env.NODEJS_PDF_URL + "/" + tracking_number + ".pdf";
                }, 1000);
                setTimeout(() => {
                    this.printPdfFromIframe();
                }, 4000);

                return;
            }

            // 7-11: redemption_waybill
            if (courier === "7-11") {
                await this.$http({
                    url: this.NODEJS_API_URL + "/redemption_waybill",
                    method: "POST",
                    data: {
                        ids: [tracking_number],
                        print_packing: false,
                        print_waybill: true,
                        no_of_waybill: total_ctns,
                        print_as_file: 1
                    }
                });

                this.pdf_to_print =
                    process.env.NODEJS_PDF_URL + "/" + tracking_number + ".pdf";

                setTimeout(() => {
                    this.printPdfFromIframe();
                }, 4000);

                return;
            }

            // Other couriers except sf-cn: use existing FTP waybill endpoint
            if (courier !== "sf-cn") {
                let pdf_to_print_src = encodeURIComponent(
                    tracking_obj.courier_short_name.toUpperCase() +
                    "/" +
                    tracking_obj.tracking_number
                );

                this.pdf_to_print =
                    "https://sys.gols.com.hk/api/download_ftp_waybill.php?url=" +
                    pdf_to_print_src;

                setTimeout(() => {
                    this.printPdfFromIframe();
                }, 4000);

                return;
            }

            // sf-cn: currently no auto print branch in original fulfilment flow
            this.showAlert(
                `Cartons updated, but auto print is not configured for courier [${tracking_obj.courier_short_name}]`,
                "warning"
            );
        },

        async onSubmit(tracking_number) {
            this.resetAlert();

            if (!this.isValidCartons()) {
                this.showAlert("Invalid cartons", "danger");
                return;
            }

            if (!tracking_number || tracking_number === "") return;
            if (this.printing) return;

            this.printing = true;

            const submitted_ctns = parseInt(this.carton_obj.ctns, 10) || 1;

            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            try {
                let response = await this.$http({
                    method: "POST",
                    baseURL: `${this.API_HOST}`,
                    url: "carton_amendment_scan.php",
                    data: {
                        carton_obj: {
                            ...this.carton_obj,
                            tracking_number
                        },
                        client_id: this.$store.state.user_obj.client_id,
                        user_id: this.$store.state.user_obj.user_id
                    }
                });

                this.camera_cooldown = true;
                setTimeout(() => {
                    this.camera_cooldown = false;
                }, 2000);

                if (response.data.status === "success") {
                    this.showAlert("Total cartons are updated", "success");

                    this.scan_history = [
                        ...(response.data.orders || []),
                        ...this.scan_history
                    ];

                    // Auto print waybill after carton amendment success
                    await this.autoPrintWaybill(tracking_number, submitted_ctns);

                    this.clearTrackingInput();
                    this.focusTrackingInput();
                } else {
                    this.loader.hide();
                    this.showAlert(
                        `[${tracking_number}] ${response.data.message}`,
                        "danger"
                    );
                }
            } catch (err) {
                this.loader.hide();
                console.log("onSubmit error", err);
                this.showAlert(
                    `[${tracking_number}] Failed to update cartons`,
                    "danger"
                );
            } finally {
                this.printing = false;
            }
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}

.span-status {
    display: none;
}

.container-status:hover .span-status {
    display: inline;
}

.row-status_cnt {
    display: flex;
}

.scanner-container video {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/CartonAmendment.vue